import { useMe } from "@@/authentication/me/me-context";
import { AccountIcon } from "@@/shared/account-icon";
import { ButtonPrimaryLight } from "@@/shared/buttons_v2/button-primary-light";
import { VerticalDivider } from "@@/shared/dividers";
import { FlexColumn, FlexRow } from "@@/shared/flex-containers";
import { GlobalMaxWidthCss } from "@@/shared/global-max-width";
import { Icon } from "@@/shared/icons/icon";
import { LoginButton } from "@@/shared/login-button";
import { Paragraph, paragraphLineBreakFactory, TextBox } from "@@/shared/text";
import { useTheme } from "@emotion/react";
import { faLock } from "@fortawesome/pro-solid-svg-icons";
import type { RemSize} from "@towni/common";
import { translation } from "@towni/common";

type Props = {
    type?: "unAuthorized" | "unAuthenticated";
};

const AccessDeniedPage = (props: Props) => {
    const [me] = useMe();
    const theme = useTheme();

    const isUnauthenticated = !me || props.type === "unAuthenticated";
    // const isUnauthorized = props.type === "unAuthorized";
    const status = isUnauthenticated ? "unAuthenticated" : "unAuthorized";
    return (
        <>
            <GlobalMaxWidthCss />
            <FlexColumn
                fillParent
                mainAxis="center"
                crossAxis="center"
                css={{
                    backgroundColor: theme.colors.default.background.asString,
                }}>
                <FlexColumn
                    mainAxis="center"
                    crossAxis="center"
                    css={{ flex: 1, paddingBottom: 40 }}>
                    <FlexColumn
                        mainAxis="center"
                        crossAxis="center"
                        css={{
                            backgroundColor:
                                theme.colors.default.background.asString,
                            borderRadius: 20,
                            overflow: "hidden",
                            padding: 20,
                        }}>
                        <FlexRow
                            fillParentWidth
                            mainAxis="center"
                            crossAxis="center"
                            css={{ paddingTop: 10 }}>
                            <Icon
                                icon={faLock}
                                size={3 as RemSize}
                                color={theme.colors.black.light50}
                            />
                        </FlexRow>
                        <VerticalDivider M />
                        <TextBox
                            text={{
                                sv: "Åtkomst nekad",
                                en: "Access denied",
                            }}
                            weight="900"
                            size="XL"
                            align="center"
                            padding={{ all: 20 }}
                        />
                        {status === "unAuthenticated" ? (
                            <>
                                <TextBox
                                    text={{
                                        sv: "Du kanske behöver logga in?",
                                        en: "Have you tried login in?",
                                    }}
                                    weight="400"
                                    size="ML"
                                    align="center"
                                />
                                <VerticalDivider XL />
                                <LoginButton
                                    theme="PRIMARY"
                                    size={1.2 as RemSize}
                                />
                            </>
                        ) : null}
                        {status === "unAuthorized" ? (
                            <>
                                <Paragraph
                                    css={{
                                        fontWeight: 400,
                                        textAlign: "center",
                                        fontSize: theme.sizes.inPixels.ML,
                                        lineHeight: theme.sizes.inRem.ML * 1.2,
                                    }}
                                    content={[
                                        translation({
                                            sv: "Du har inte åtkomst till efterfrågad resurs.",
                                            en: "You don't have access to the requested resource.",
                                        }),
                                        paragraphLineBreakFactory(),
                                        translation({
                                            sv: "Är du inloggad på rätt konto?",
                                            en: "Are you logged in on the correct account?",
                                        }),
                                    ]}
                                />
                                <VerticalDivider XL />
                                <ButtonPrimaryLight
                                    css={{ borderRadius: 3000 }}>
                                    <AccountIcon
                                        disableShadow
                                        size={1.2}
                                        showName
                                        hideChevron
                                        color={theme.colors.primary}
                                    />
                                </ButtonPrimaryLight>
                            </>
                        ) : null}
                    </FlexColumn>
                </FlexColumn>
            </FlexColumn>
        </>
    );
};
export { AccessDeniedPage };
